import { c as _c } from "react/compiler-runtime";
import { Card, type TableRow } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import type { FormattedName } from '../../../../../../onboarding-business-insight.types';
import FlushTable from '../../../flush-table';
import MobileRow from './components/mobile-row';
import Row from './components/row';
type BusinessNameListProps = {
  data: FormattedName[];
  onOpen: (id: string) => void;
};
const BusinessNameList = t0 => {
  const $ = _c(19);
  const {
    data,
    onOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.businessDetails.name.table"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isMobile = useMobileLayout();
  if (!data.length) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <Card.Empty>{t2}</Card.Empty>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== isMobile || $[6] !== t) {
    t2 = isMobile ? [{
      text: t(_temp2)
    }] : [{
      text: t(_temp3),
      width: "65%"
    }, {
      text: t(_temp4),
      width: "35%"
    }];
    $[5] = isMobile;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const columns = t2;
  let t3;
  if ($[8] !== isMobile || $[9] !== onOpen) {
    t3 = t4 => {
      const {
        item
      } = t4;
      return isMobile ? <MobileRow businessName={item} onOpen={onOpen} /> : <Row businessName={item} onOpen={onOpen} />;
    };
    $[8] = isMobile;
    $[9] = onOpen;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const renderTr = t3;
  let t4;
  if ($[11] !== t) {
    t4 = t(_temp5);
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== columns || $[14] !== data || $[15] !== isMobile || $[16] !== renderTr || $[17] !== t4) {
    t5 = <Card.Body className="pt-2.75 pb-3"><FlushTable aria-label={t4} columns={columns} getKeyForRow={_temp6} hideThead={isMobile} items={data} renderTr={renderTr} /></Card.Body>;
    $[13] = columns;
    $[14] = data;
    $[15] = isMobile;
    $[16] = renderTr;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default BusinessNameList;
function _temp($) {
  return $.emptyState;
}
function _temp2($_0) {
  return $_0.header.name;
}
function _temp3($_1) {
  return $_1.header.name;
}
function _temp4($_2) {
  return $_2.header.type;
}
function _temp5($_3) {
  return $_3.ariaLabel;
}
function _temp6(businessName) {
  return `${businessName.name} ${businessName.kind}`;
}